import React from 'react';
import './Sent_gift.css';
import { Link } from 'react-router-dom';

class Sent_gift extends React.Component {
    render () {
        return (
            <Link to={`/gifts/${this.props.gift_id}`}>
                <div className='gift'>
                    <div className='gift_left_side'>
                        <p className='l1'>Gift to {this.props.giftTo}</p>
                        <p className='small_text l2'>Delivery Date</p>
                        {this.props.is_monthly_gift && (
                            <span className='monthly_gift_sent_badge'>
                                <i className='material-icons monthly_gift_badge_icon'>refresh</i>
                                Monthly
                            </span>
                        )}
                    </div>
                    <div className='gift_right_side'>
                        <p className='money l1'>${this.props.giftAmount}</p>
                        <p className='small_text l2'>{this.props.giftDate}</p>
                    </div>
                </div>
            </Link>
        );
    }
}

export default Sent_gift;
